import { render, staticRenderFns } from "./ChallengeTable.vue?vue&type=template&id=7c59c1db&scoped=true&"
import script from "./ChallengeTable.vue?vue&type=script&lang=ts&"
export * from "./ChallengeTable.vue?vue&type=script&lang=ts&"
import style0 from "./ChallengeTable.vue?vue&type=style&index=0&id=7c59c1db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59c1db",
  null
  
)

export default component.exports